/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementContactHistoryListResponse } from '../../models/asset-management-contact-history-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerFindAllAssetManagementContactHistory$Params {
  id: number;

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  registry_end_customer_contact_last_name?: string;
  registry_end_customer_contact_first_name?: string;
  related_user_id?: number;
  created_on_from?: string;
  created_on_to?: string;
  order_by?: string;
  order_direction?: string;
}

export function assetManagementControllerFindAllAssetManagementContactHistory(http: HttpClient, rootUrl: string, params: AssetManagementControllerFindAllAssetManagementContactHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementContactHistoryListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerFindAllAssetManagementContactHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('registry_end_customer_contact_last_name', params.registry_end_customer_contact_last_name, {});
    rb.query('registry_end_customer_contact_first_name', params.registry_end_customer_contact_first_name, {});
    rb.query('related_user_id', params.related_user_id, {});
    rb.query('created_on_from', params.created_on_from, {});
    rb.query('created_on_to', params.created_on_to, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementContactHistoryListResponse;
      }>;
    })
  );
}

assetManagementControllerFindAllAssetManagementContactHistory.PATH = '/asset-management/{id}/contact-history';
